module.exports = {
//  const currencies = {
  'AED': {symbol:'د.إ',precision:2},
  'AFN': {symbol:'؋',precision:2},
  'ALL': {symbol:'L',precision:2},
  'AMD': {symbol:'֏',precision:2},
  'ANG': {symbol:'ƒ',precision:2},
  'AOA': {symbol:'Kz',precision:2},
  'ARS': {symbol:'$',precision:2},
  'AUD': {symbol:'$',precision:2},
  'AWG': {symbol:'ƒ',precision:2},
  'AZN': {symbol:'₼',precision:2},
  'BAM': {symbol:'KM',precision:2},
  'BBD': {symbol:'$',precision:2},
  'BDT': {symbol:'৳',precision:2},
  'BGN': {symbol:'лв',precision:2},
  'BHD': {symbol:'.د.ب',precision:3},
  'BIF': {symbol:'FBu',precision:0},
  'BMD': {symbol:'$',precision:2},
  'BND': {symbol:'$',precision:2},
  'BOB': {symbol:'$b',precision:2},
  'BRL': {symbol:'R$',precision:2},
  'BSD': {symbol:'$',precision:2},
  'BTC': {symbol:'฿',precision:2},
  'BTN': {symbol:'Nu.',precision:2},
  'BWP': {symbol:'P',precision:2},
  'BYR': {symbol:'Br',precision:0},
  'BYN': {symbol:'Br',precision:2},
  'BZD': {symbol:'BZ$',precision:2},
  'CAD': {symbol:'$',precision:2},
  'CDF': {symbol:'FC',precision:2},
  'CHF': {symbol:'CHF',precision:2},
  'CLP': {symbol:'$',precision:0},
  'CNY': {symbol:'¥',precision:2},
  'COP': {symbol:'$',precision:2},
  'CRC': {symbol:'₡',precision:2},
  'CUC': {symbol:'$',precision:2},
  'CUP': {symbol:'₱',precision:2},
  'CVE': {symbol:'$',precision:2},
  'CZK': {symbol:'Kč',precision:2},
  'DJF': {symbol:'Fdj',precision:0},
  'DKK': {symbol:'kr',precision:2},
  'DOP': {symbol:'RD$',precision:2},
  'DZD': {symbol:'دج',precision:2},
  'EEK': {symbol:'kr',precision:2},
  'EGP': {symbol:'£',precision:2},
  'ERN': {symbol:'Nfk',precision:2},
  'ETB': {symbol:'Br',precision:2},
  'EUR': {symbol:'€',precision:2},
  'FJD': {symbol:'$',precision:2},
  'FKP': {symbol:'£',precision:2},
  'GBP': {symbol:'£',precision:2},
  'GEL': {symbol:'₾',precision:2},
  'GGP': {symbol:'£',precision:2},
  'GHS': {symbol:'GH₵',precision:2},
  'GIP': {symbol:'£',precision:2},
  'GMD': {symbol:'D',precision:2},
  'GNF': {symbol:'FG',precision:0},
  'GTQ': {symbol:'Q',precision:2},
  'GYD': {symbol:'$',precision:2},
  'HKD': {symbol:'$',precision:2},
  'HNL': {symbol:'L',precision:2},
  'HRK': {symbol:'kn',precision:2},
  'HTG': {symbol:'G',precision:2},
  'HUF': {symbol:'Ft',precision:2},
  'IDR': {symbol:'Rp',precision:2},
  'ILS': {symbol:'₪',precision:2},
  'IMP': {symbol:'£',precision:2},
  'INR': {symbol:'₹',precision:2},
  'IQD': {symbol:'ع.د',precision:3},
  'IRR': {symbol:'﷼',precision:2},
  'ISK': {symbol:'kr',precision:0},
  'JEP': {symbol:'£',precision:2},
  'JMD': {symbol:'J$',precision:2},
  'JOD': {symbol:'JD',precision:3},
  'JPY': {symbol:'¥',precision:0},
  'KES': {symbol:'KSh',precision:2},
  'KGS': {symbol:'лв',precision:2},
  'KHR': {symbol:'៛',precision:2},
  'KMF': {symbol:'CF',precision:0},
  'KPW': {symbol:'₩',precision:2},
  'KRW': {symbol:'₩',precision:0},
  'KWD': {symbol:'KD',precision:3},
  'KYD': {symbol:'$',precision:2},
  'KZT': {symbol:'лв',precision:2},
  'LAK': {symbol:'₭',precision:2},
  'LBP': {symbol:'£',precision:2},
  'LKR': {symbol:'₨',precision:2},
  'LRD': {symbol:'$',precision:2},
  'LSL': {symbol:'M',precision:2},
  'LTL': {symbol:'Lt',precision:2},
  'LVL': {symbol:'Ls',precision:2},
  'LYD': {symbol:'LD',precision:3},
  'MAD': {symbol:'MAD',precision:2},
  'MDL': {symbol:'lei',precision:2},
  'MGA': {symbol:'Ar',precision:2},
  'MKD': {symbol:'ден',precision:2},
  'MMK': {symbol:'K',precision:2},
  'MNT': {symbol:'₮',precision:2},
  'MOP': {symbol:'MOP$',precision:2},
  'MRO': {symbol:'UM',precision:2},
  'MUR': {symbol:'₨',precision:2},
  'MVR': {symbol:'Rf',precision:2},
  'MWK': {symbol:'MK',precision:2},
  'MXN': {symbol:'$',precision:2},
  'MYR': {symbol:'RM',precision:2},
  'MZN': {symbol:'MT',precision:2},
  'NAD': {symbol:'$',precision:2},
  'NGN': {symbol:'₦',precision:2},
  'NIO': {symbol:'C$',precision:2},
  'NOK': {symbol:'kr',precision:2},
  'NPR': {symbol:'₨',precision:2},
  'NZD': {symbol:'$',precision:2},
  'OMR': {symbol:'﷼',precision:3},
  'PAB': {symbol:'B/.',precision:2},
  'PEN': {symbol:'S/.',precision:2},
  'PGK': {symbol:'K',precision:2},
  'PHP': {symbol:'₱',precision:2},
  'PKR': {symbol:'₨',precision:2},
  'PLN': {symbol:'zł',precision:2},
  'PYG': {symbol:'Gs',precision:0},
  'QAR': {symbol:'﷼',precision:2},
  'RON': {symbol:'lei',precision:2},
  'RSD': {symbol:'Дин.',precision:2},
  'RUB': {symbol:'₽',precision:2},
  'RWF': {symbol:'R₣',precision:0},
  'SAR': {symbol:'﷼',precision:2},
  'SBD': {symbol:'$',precision:2},
  'SCR': {symbol:'₨',precision:2},
  'SDG': {symbol:'ج.س.',precision:2},
  'SEK': {symbol:'kr',precision:2},
  'SGD': {symbol:'$',precision:2},
  'SHP': {symbol:'£',precision:2},
  'SLL': {symbol:'Le',precision:2},
  'SOS': {symbol:'S',precision:2},
  'SRD': {symbol:'$',precision:2},
  'STD': {symbol:'Db',precision:2},
  'SVC': {symbol:'$',precision:2},
  'SYP': {symbol:'£',precision:2},
  'SZL': {symbol:'E',precision:2},
  'THB': {symbol:'฿',precision:2},
  'TJS': {symbol:'SM',precision:2},
  'TMT': {symbol:'T',precision:2},
  'TND': {symbol:'د.ت',precision:3},
  'TOP': {symbol:'T$',precision:2},
  'TRY': {symbol:'₺',precision:2},
  'TTD': {symbol:'TT$',precision:2},
  'TWD': {symbol:'NT$',precision:2},
  'TZS': {symbol:'TSh',precision:2},
  'UAH': {symbol:'₴',precision:2},
  'UGX': {symbol:'USh',precision:0},
  'USD': {symbol:'$',precision:2},
  'UYU': {symbol:'$U',precision:2},
  'UZS': {symbol:'лв',precision:2},
  'VEF': {symbol:'Bs',precision:2},
  'VND': {symbol:'₫',precision:0},
  'VUV': {symbol:'VT',precision:0},
  'WST': {symbol:'WS$',precision:2},
  'XAF': {symbol:'FCFA',precision:0},
  'XCD': {symbol:'$',precision:2},
  'XOF': {symbol:'CFA',precision:0},
  'XPF': {symbol:'₣',precision:0},
  'YER': {symbol:'﷼',precision:2},
  'ZAR': {symbol:'R',precision:2}
}

//Vue.use(currencyInfo);